/* global helper, url, mo */
moment.locale('ru');
let bases_search = {};

$(function () {
    bases_search.$filters = $('#bases_filter');
    bases_search.$btns_filters = $('#btns_filters');
    bases_search.$form = $('[id=bases_search]');
    bases_search.$results = $('#bases_results');
    bases_search.$results_bar = $('#bases_results_bar');
    bases_search.$results_pagination = $('.bases_results_pagination');

    bases_search.form_init();
    bases_search.filter_init();
    bases_search.results_bar_init();
    bases_search.results_init();
    bases_search.tabs_init();

    // scrollbar для блока фильтров
    if (bases_search.$filters.length) {
        bases_search.$filters.TrackpadScrollEmulator({autoHide: false});
    }
    /*if($('.scroll_block').length){
        $('.scroll_block:not(.full)').jScrollPane();
    }*/

    // схлопывание панелек
    $('.hasSlide', bases_search.$filters).click(function (e) {
        e.preventDefault();
        $(this).closest('.el').toggleClass('open');
    });

    // подгрузка слайдеров для первых баз
    setTimeout(function () {
        $.map($('.els .el:not(.empty)', bases_search.$results), function (el) {
            bases_search.load_slider($(el));
        });
    }, 500);

    /*if ($('#filter_wrapper').length) {
        let filterWrapper = $('#filter_wrapper'),
            filterWrapperTop = $('#filter_wrapper').offset().top;
        $(window).resize(function () {
            filterWrapperTop = $('#filter_wrapper').offset().top;
        });
        $(window).scroll(function () {
            let footerTop = $('#footer').offset().top; // координаты футера

            if ($(this).scrollTop() > filterWrapperTop && $(this).width() > 1044) {
                filterWrapper.addClass('fixed');
                if (($(this).height() + $(this).scrollTop()) < footerTop) {
                    filterWrapper.css({top: ($(this).scrollTop() - filterWrapperTop)});
                }
            } else {
                filterWrapper.removeClass('fixed');
                filterWrapper.css({top: 0});
            }
        });
    }*/
});


// загрузка слайдеров для найденных баз
bases_search.load_slider = function ($el) {
    let $slider = $('.imageSlider', $el);
    if (!$slider.data('slider')) {
        // показываем активные картинки базы
        mo.preloader(true, $slider);
        mo.get(function (result) {
            mo.preloader(false, $slider);
            $slider.data('slider', true);
            if (result.error) return;

            let slider_content = '';
            $.map(result, function (image) {
                slider_content += '<div class="slide"><img src="/images/bases/' + image.base_id + '/thumbs/' + image.md5 + '.jpg" /></div>'
            });

            $('.sliderWrapper', $slider).html(slider_content).slick({
                prevArrow: '<span class="slick-prev"><span class="icon-chevron-left"></span></span>',
                nextArrow: '<span class="slick-next"><span class="icon-chevron-right"></span></span>'
            });

        }, 'bases', 'slider_images', {base_id: $el.data('id')});
    }
};

// загрузить базы в соответствии с фильтром
// no_search - используется не на странице поиска
bases_search.load_bases = function (no_search_page, type_view_strict, condition_strict, only_condition_strict) {
    if (no_search_page == undefined) no_search_page = 0;

    var type_view;
    if (no_search_page) type_view = 1;
    else type_view = $('[name=type_view]', bases_search.$results_bar).val() * 1;

    var action = bases_search.get_form_action(true, bases_search.$form);
    hash = bases_search.$form.data('hash') || 'bases_search';
    if (!no_search_page) window.history.pushState(null, null, action + '#' + hash);

    // если только параметры указанные вручную
    if (only_condition_strict) {
        action = 't=1&type_view=' + type_view;
    }

    // вид вывода указан вручную
    if (type_view_strict) {
        type_view = type_view_strict;
        action = action.replace(/type_view=\d+/, '&type_view=1');
    }

    if (condition_strict) action += condition_strict; // условие поиска, указанное вручную

    var get_params = action.replace(/^.*?\?/, '');
    get_params += '&data_block=bases&getFormat=' + (type_view ? 'json' : 'template_search') + '&template_name=bases/search_el';

    var pageLang = $('#page_lang').val();
    get_params += '&pagelang=' + pageLang;

    $('.els', bases_search.$results).addClass('block-loading-fade');
    mo.get(function (result) {
        $('.els', bases_search.$results).html('');
        $('.els', bases_search.$results).removeClass('block-loading-fade');

        if (!type_view) {
            bases_search.insert_results_regular(result);
        } else {
            bases_search.insert_results_map(result.bases);
        }

        tooltip_init();
    }, 'bases', 'search_new&' + get_params);
};

bases_search.load_bases_map_points = function () {
    let Storage = window.sessionStorage;
    let bases_map_points = '';
    let bases_map_points_cache_time = 0;

    if (helper.isLocalStorageNameSupported()) {
        bases_map_points = Storage.bases_map_points; // кооординаты баз
        bases_map_points_cache_time = Storage.bases_map_points_cache_time; // время поледнего кеширования данных
    }

    let now_time = new Date().getTime(); // текущее время;

    //если нет данных в кеше браузера или кэш протух (старше чем 1 день), делаем запрос на сервер для получения точек
    if (!bases_map_points || !bases_map_points_cache_time || (bases_map_points_cache_time + 300000) < now_time) {
        mo.get(function (result) {
            if (result.error) return;
            if (helper.isLocalStorageNameSupported()) {
                try {
                    Storage.setItem('bases_map_points', JSON.stringify(result)); // сохраняем данные
                    Storage.setItem('bases_map_points_cache_time', now_time); // время последнего кеширования
                } catch (e) {
                }
            }
            bases_search.insert_results_map(result);
        }, 'bases', 'bases_map_point');
    } else {
        let result = JSON.parse(bases_map_points);
        bases_search.insert_results_map(result);
    }
};

// функции формы поиска
bases_search.form_init = function () {
    let $form = bases_search.$form;

    $('input', $form).focusin(function () {
        $(this).next('[class*="icon-"]').addClass('focus');
    });
    $('input[name=search_str]', $form).focusin(function () {
        $(this).parent().next('[class*="icon-"]').addClass('focus');
    });
    $('input[name=search_str]', $form).focusout(function () {
        $(this).parent().next('[class*="icon-"]').removeClass('focus');
    });
    $('.icon-location', $form).click(function () {
        $('input[name=search_str]', $form).focus();
    });
    $('input:not([name=peoples])', $form).focusout(function () {
        $(this).next('[class*="icon-"]').removeClass('focus');
    });
    $('.icon-peoples', $form).click(function () {
        $('input[name=peoples]', $form).focus();
    });

    // автоподсказки
    let timer, $results = $('[name=search_str]', $form).siblings('.autocomplete-results');

    $('[name=search_str]', $form).on('keyup input', function (e) {
            let search = e.target.value.toLowerCase();

            if (!(search && search.length >= 3)) return false;
            clearTimeout(timer);
            $results.html('');
            timer = setTimeout(function() {
                mo.get(function (res) {
                    if (!res.error) {
                        let result_list = '';
                        if (res.regions) {
                            $.map(res.regions, function ($el) {
                                result_list += '<a href="" data-addr_id="' + $el.id + '" data-aolevel="' + $el.aolevel + '" target="_blank" class="region cf"><span>' +
                                    $el.name + '</span><i>' +
                                    $el.type_name + '</i></a>';
                            });
                        }
                        if (res.resorts) {
                            $.map(res.resorts, function ($el) {
                                result_list += '<a href="" data-resort_id="' + $el.id + '" target="_blank" class="region cf"><span>' +
                                    $el.name + '</span><i>курорт</i></a>';
                            });
                        }
                        if (res.waters) {
                            $.map(res.waters, function ($el) {
                                result_list += '<a href="" data-water_id="' + $el.id + '" target="_blank" class="water cf"><span>' +
                                    $el.name + '</span><i>' +
                                    $el.type_name + '</i></a>';
                            });
                        }
                        if (res.bases) {
                            $.map(res.bases, function ($el) {
                                result_list += '<a href="/' + $el.region_translit + '/id' + $el.id + '/" data-search_type="bases" target="_blank" class="base cf"><span>' +
                                    $el.name + '</span><i class="icon-house2"></i><span class="base_region">' +
                                    $el.region_name + '</span></a>';
                            });
                        }
                        if (!res.regions && !res.resorts && !res.waters && !res.bases) {
                            result_list = '<a href="" class="empty">По Вашему запросу ничего не найдено</a>';
                        }
                        $results.append(result_list).fadeIn();
                    }
                }, 'bases', 'new_search_autocomplete', {search: search});
                /*$.post({
                    url: '/ajax/search.php',
                    data: {t: 'autocomplete', q: search},
                    success: function(data){
                        console.log(data);
                        try{

                            $results.empty().hide();

                            var count = {bases: 0, resorts: 0, regions: 0, districts: 0, waters: 0};

                            parsed = JSON.parse(data);

                            for(result in parsed.results){
                                if(parsed.results.hasOwnProperty(result)){

                                    var element = '';

                                    result = parsed.results[result];

                                    switch(result.type){
                                        case 'base':
                                            count.bases++;
                                            element = '<a href="/' + result.region_translit + '/id' + result.id + '/" target="_blank" class="base cf ' + (count.bases === 1 ? 'first' : '') + '"><span>' +
                                                result.name + '</span><i>' +
                                                (result.type_name || '') + '</i><span class="base_region">' +
                                                result.region_name + '</span></a>';
                                            break;
                                        case 'resort':
                                            count.resorts++;
                                            element = '<a href="" data-resort_id="' + result.id + '" target="_blank" class="region cf ' + (count.resorts === 0 ? 'first' : '') + '"><span>' +
                                                result.name + '</span><i>курорт</i></a>';
                                            break;
                                        case 'region':
                                            count.regions++;
                                            element = '<a href="" data-region_id="' + result.id + '" target="_blank" class="region cf ' + (count.regions === 0 ? 'first' : '') + '"><span>' +
                                                result.name + '</span><i>' +
                                                result.type_name + '</i></a>';
                                            break;
                                        case 'district':
                                            count.districts++;
                                            element = '<a href="" data-region_id="' + result.pid + '" data-district_id="' + result.id + '" target="_blank" class="region cf ' + (count.districts === 0 ? 'first' : '') + '"><span>' +
                                                result.name + '</span><i>' +
                                                result.type_name + '</i></a>';
                                            break;
                                        case 'water':
                                            count.waters++;
                                            element = '<a href="" data-water_id="' + result.id + '" target="_blank" class="water cf ' + (count.waters == 0 ? 'first' : '') + '"><span>' +
                                                result.name + '</span><i>' +
                                                result.type_name + '</i></a>';
                                            break;
                                        default:
                                            break;
                                    }

                                    $results.append(element);

                                }
                            }

                            $results[0].childElementCount > 0 && $results.show();

                        }
                        catch(err){
                        }
                    },
                    data_type: 'json'
                });*/
            }, 500);

        });

        $('[name=search_str]', $form).on('input', function (e) {
            $(this)
                .data('region_id', '')
                .data('district_id', '')
                .data('city_id', '')
                .data('resort_id', '')
                .data('water_id', '')
                .data('bases_ids', '');
        });
    /*.blur(function(){
        $(this).val($(this).attr('value'));
    });*/

    $('.search_str-wrapper', $form).on('mousedown', '.autocomplete-results a', function (event) {
        event.preventDefault();

        let $input = $('[name=search_str]', $form);

        let $results = $(this).closest('.autocomplete-results');
        let name = $('span', this).text();

        let type_name = $('i', this).text(),
            value = name,
            hrValue = String.prototype.capitalize(value),
            region_id = (parseInt($(this).data('aolevel')) === 1) ? $(this).data('addr_id') : '',
            district_id = (parseInt($(this).data('aolevel')) === 3) ? $(this).data('addr_id') : '',
            city_id = (parseInt($(this).data('aolevel')) === 4) ? $(this).data('addr_id') : '',
            resort_id = $(this).data('resort_id') || '',
            water_id = $(this).data('water_id') || '',
            bases_ids = $(this).data('bases_ids') || '';

        bases_search.save_query_history(hrValue);

        if ($(this).attr('href')) return; // это ссылка на страницу

        if ($(this).is(':not(.empty)')) {
            $input
                .attr('value', value).val(hrValue)
                .data('region_id', region_id)
                .data('district_id', district_id)
                .data('city_id', city_id)
                .data('resort_id', resort_id)
                .data('water_id', water_id)
                .data('bases_ids', bases_ids)
        }

        $results.empty().hide();

        $form.submit();
    });
    // /автоподсказки

    // выбор дат
    let date_i18n = {
        nextMonth: '',
        previousMonth: '',
        months: ["ЯНВАРЬ", "ФЕВРАЛЬ", "МАРТ", "АПРЕЛЬ", "МАЙ", "ИЮНЬ", "ИЮЛЬ", "АВГУСТ", "СЕНТЯБРЬ", "ОКТЯБРЬ", "НОЯБРЬ", "ДЕКАБРЬ"],
        weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
        weekdaysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
    };
    $.map($('.dates_block'), function (dForm) {
        let startField = $('.date_input[name="date1"]', dForm),
            endField = $('.date_input[name="date2"]', dForm),
            startDate,
            endDate,
            updateStartDate = function () {
                var endMinDate = new Date(startDate.getTime());
                endMinDate.setDate(endMinDate.getDate() + 1);

                startPicker.setStartRange(startDate);
                endPicker.setStartRange(endMinDate);
                endPicker.setMinDate(endMinDate);
                startPicker.gotoMonth(startDate.getMonth());
                startPicker.gotoYear(startDate.getFullYear());
                endPicker.gotoMonth(startDate.getMonth());
                endPicker.gotoYear(startDate.getFullYear());
            },
            updateEndDate = function () {
                startPicker.setEndRange(endDate);
                endPicker.setEndRange(endDate);
            },
            startPicker = new Pikaday({
                i18n: date_i18n,
                position: 'bottom left',
                reposition: false,
                firstDay: 1,
                format: 'DD MMMM, ddd',
                field: startField.get(0),
                minDate: new Date(),
                maxDate: new Date(2025, 12, 31),
                onSelect: function () {
                    startDate = this.getDate();
                    $('.date_notice', dForm).hide();
                    $('.deactivete_input', dForm).addClass('hidden');
                    updateStartDate();
                    //обновляем значение дат
                    startField.data('value', moment(startDate).format('YYYY-MM-DD'));

                    // проверяем даты
                    let date1_val = startField.data('value'),
                        date2_val = endField.data('value'),
                        date1 = new Date(date1_val),
                        date2 = new Date(date2_val);
                    if (!date2_val || (date2.getTime() <= date1.getTime())) {
                        endField.data('value', '').val('');
                        endField.click();
                    }
                    startField.change();
                },
                onOpen: function () {
                    startField.closest('.date_wr').addClass('focus');
                },
                onClose: function () {
                    if (!startField.val().length) {
                        startField.closest('.date_wr').removeClass('focus');
                    }
                }
            }),
            endPicker = new Pikaday({
                i18n: date_i18n,
                position: 'bottom right',
                reposition: false,
                firstDay: 1,
                format: 'DD MMMM, ddd',
                field: endField.get(0),
                maxDate: new Date(2025, 12, 31),
                onSelect: function () {
                    endDate = this.getDate();
                    updateEndDate();

                    endField.data('value', moment(endDate).format('YYYY-MM-DD'));
                    endField.change();
                },
                onOpen: function () {
                    endField.closest('.date_wr').addClass('focus');
                },
                onClose: function () {
                    if (!endField.val().length) {
                        endField.closest('.date_wr').removeClass('focus');
                    }
                }
            }),
            _startDate = startField.data('value') ? new Date(startField.data('value')) : startPicker.getDate(),
            _endDate = endField.data('value') ? new Date(endField.data('value')) : endPicker.getDate();

        startField.data('pikaday', startPicker);
        endField.data('pikaday', endPicker);
        if (_startDate) {
            startDate = _startDate;
            updateStartDate();
        }

        if (_endDate) {
            endDate = _endDate;
            updateEndDate();
        }
    });

    // Если не выбрана дата заезда
    $('.dates_block .deactivete_input').click(function () {
        let bl = $(this).closest('.dates_block');
        $('.date_notice', bl).show();
        $('[name="date1"]', bl).click();
    });


    // визуальное изменение количества гостей
    $('[name=peoples]', $form).change(function () {
        var $form = $(this).closest('form');

        var adults = $(this).data('adults') * 1;
        var childrens = $(this).data('childrens') + '';
        var $peoples_label = $('.peoples', $form);

        var value = '';
        $peoples_label.text('');

        if (adults) {
            value = adults;
            if (childrens) {
                childrens_count = childrens.split(',').length;
                value += ' + ' + childrens_count;

                //if(childrens_count <= 6) $peoples_label.text('(' + childrens.replace(/,/g, '+') + ')');
                if (childrens_count <= 6) $peoples_label.text('(' + childrens + ')');
            }
        }

        $(this).val(value);
    }).change();

    // окно выбора количества гостей

    var options_peoples = '';
    /*
    for (var i = 0; i <= 1000; i++) options_peoples += '<option value="' + i + '">' + i + '</option>';
    */
    var options_olds = '';
    for (var i = 2; i <= 17; i++) options_olds += '<option value="' + i + '" ' + ((i == 8) ? 'selected' : '') + '>' + i + '</option>';

    var $select_peoples = $('.select_peoples', $form);
    $('[name=adults]', $select_peoples).html(options_peoples);
    $('[name=childrens]', $select_peoples).html(options_peoples);

    // выбор количества гостей
    $('[name=peoples]', $form).focus(function () {

        var $form = $(this).closest('form');
        var $select_peoples = $('.select_peoples', $form);

        $(this).addClass('focus').next().addClass('focus');

        var adults = $(this).data('adults') * 1;
        var childrens = $(this).data('childrens') + '';
        var children_count = childrens ? childrens.split(',').length : 0;

        $('[name=adults]', $select_peoples).val(adults).change();
        $('[name=childrens]', $select_peoples).val(children_count).change();

        $('.select_peoples', $form).show();

        var select_peoples_show = true;
        $(document).bind('click.select_peoples', function (e) {
            if (!select_peoples_show && $(e.target).closest('.select_peoples').length == 0) {
                $('.select_peoples', $form).hide();
                $(document).unbind('click.select_peoples');
            }
            select_peoples_show = false;
        });
        $(this).blur();
    });

    // изменение количества детей
    $('[name=childrens]', $select_peoples).change(function () {
        var $form = $(this).closest('form');
        var $select_peoples = $('.select_peoples', $form);

        var childrens_count = $(this).val() * 1;

        if (childrens_count)
            $('.for_childrens', $select_peoples).show();
        else
            $('.for_childrens', $select_peoples).hide();

        if (childrens_count == 0)
            $('.olds .select', $select_peoples).remove();
        else
            $('.olds [name="olds[]"]:gt(' + (childrens_count - 1) + ')', $select_peoples).closest('.select').remove();

        var already_added = $('.olds [name="olds[]"]', $select_peoples).length;
        for (var i = 1; i <= childrens_count - already_added; i++)
            $('.olds', $select_peoples).append(helper.insertSelect('olds[]', options_olds));
        $('.olds select', $select_peoples).change();

        // проставить установленные значения возрастов
        var childrens_olds = $('[name=peoples]', $form).data('childrens') + '';
        if (childrens_olds) {
            childrens_olds = childrens_olds.split(',');
            $.map(childrens_olds, function (old, index) {
                $('.select_peoples .olds select', $form).eq(index).val(old).trigger('change.design');
            });
        }
    });

    // закрыть окно выбора количества гостей
    $('.select_peoples .cancel, .select_peoples .ok', $form).click(function (event) {
        event.preventDefault();

        var $form = $(this).closest('form');
        $('.select_peoples', $form).hide();

        $('[name=peoples]', $form).removeClass('focus')
            .next().removeClass('focus');

        $(document).unbind('click.select_peoples');
    });

    // сбросить выбор количества гостей
    $('.select_peoples .cancel', $form).click(function () {
        var $form = $(this).closest('form');
        $('[name=peoples]', $form).data('adults', 2).data('childrens', '').change();
    });

    // сохранить выбранное число гостей
    $('.select_peoples :not(.cancel)', $form).click(function () {
        var $form = $(this).closest('form');
        var $select_peoples = $('.select_peoples', $form);

        var adults = $('[name=adults]', $select_peoples).val();
        var childrens = [];
        $.map($('[name="olds[]"]', $select_peoples), function (el) {
            childrens.push($(el).val());
        });
        childrens = childrens.join(',');

        $('[name=peoples]', $form).data('adults', adults).data('childrens', childrens).change();
    });

    $form.submit(function (event) {
        event.preventDefault();
        let $form = $(this);
        if ($('.autocomplete-results', $form).is(':visible')) return; // идет выбор из списка автозаполнения

        let region_id = $('[name=search_str]', $form).data('region_id') || '',
            district_id = $('[name=search_str]', $form).data('district_id') || '',
            city_id = $('[name=search_str]', $form).data('city_id') || '',
            resort_id = $('[name=search_str]', $form).data('resort_id') || '',
            water_id = $('[name=search_str]', $form).data('water_id') || '',
            bases_ids = $('[name=search_str]', $form).data('bases_ids') || '',
            $rooms = $form.closest('#rooms'); // страница базы

        let date1 = $('input[name=date1]', $form).data('value'),
            date2 = $('input[name=date2]', $form).data('value'),
            date1_o = new Date(date1),
            date2_o = new Date(date2),
            n_nigths = (date2_o.getTime() - date1_o.getTime()) / 86400 / 1000;

        if (n_nigths > 31) {
            $('.dates_notice_2', $form).fadeOut().fadeIn();
            return helper.animateScrollTo($form, -60);
        } else {
            $('.dates_notice, .dates_notice_2', $form).hide();
        }

        if (bases_search.$btns_filters.length) {
            $('a.go', bases_search.$btns_filters).click();
        } else {
            location.href = bases_search.get_form_action(false, $form);
        }
    });

};

// генерация строки поиска
bases_search.get_form_action = function (include_filters, $form) {
    if ($form == undefined) $form = bases_search.$form.eq(0);
    let $filters = bases_search.$filters;
    if (include_filters == undefined) include_filters = ($filters.length == 1);

    // стандартные параметры из запроса
    let params = window
        .location
        .search
        .replace('?', '')
        .split('&')
        .reduce(
            function (p, e) {
                let a = e.split('=');
                p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
                return p;
            },
            {}
        );


    let search_str = $('[name=search_str]', $form).val(),
        region_id = $('[name=search_str]', $form).data('region_id') || '',
        district_id = $('[name=search_str]', $form).data('district_id') || '',
        city_id = $('[name=search_str]', $form).data('city_id') || '',
        resort_id = $('[name=search_str]', $form).data('resort_id') || '',
        water_id = $('[name=search_str]', $form).data('water_id') || '',
        bases_ids = $('[name=search_str]', $form).data('bases_ids') || '',

        date1 = $('input[name=date1]', $form).data('value'),
        date2 = $('input[name=date2]', $form).data('value'),

        adults = $('[name=peoples]', $form).data('adults') * 1,
        childrens = $('[name=peoples]', $form).data('childrens') + '',

        type_view = $('[name=type_view]', bases_search.$results_bar).val() || 0; // 0 - обычный поиск, 1 - поиск с картой

    let action = $form.attr('action');
    action = action ? action.replace(/\?.*/, '') : '';
    action += '?u_search=true' +
        (search_str ? '&search_str_text=' + search_str : '') +
        (region_id ? '&region_id=' + region_id : '') +
        (district_id ? '&district_id=' + district_id : '') +
        (city_id ? '&city_id=' + city_id : '') +
        (resort_id ? '&resort_id=' + resort_id : '') +
        (water_id ? '&water_id=' + water_id : '') +
        (bases_ids ? '&bases_ids=' + bases_ids : '') +
        (date1 ? '&date1=' + date1 : '') +
        (date2 ? '&date2=' + date2 : '') +
        (adults ? '&adults=' + adults : '') +
        (childrens ? '&childrens=' + childrens : '');

    action += '&type_view=' + type_view;

    // параметры фильтра
    if (include_filters) {
        // список регионов из фильтра
        let regions_list = [];
        $.map($('[name="region_id[]"]:checked:not(:disabled)', $filters), function (input) {
            regions_list.push($(input).val());
        });
        regions_list = regions_list.join(',');

        // список курортов из фильтра
        let resorts_list = [];
        $.map($('[name="resort_id[]"]:checked:not(:disabled)', $filters), function (input) {
            resorts_list.push($(input).val());
        });
        resorts_list = resorts_list.join(',');

        // список водоемов из фильтра
        let waters_list = [];
        $.map($('[name="water_id[]"]:checked:not(:disabled)', $filters), function (input) {
            waters_list.push($(input).val());
        });
        waters_list = waters_list.join(',');

        // список типов номеров из фильтра
        let room_types = [];
        $.map($('[name="room_type[]"]:checked:not(:disabled)', $filters), function (input) {
            room_types.push($(input).val());
        });
        room_types = room_types.join(',');

        let services = [];
        $.map($('[name="services[]"]:checked:not(:disabled)', $filters), function (input) {
            services.push($(input).val());
        });
        services = services.join(',');

        let edge_price_min = $('#price_range_filter', $filters).data('min'); // крайнее значение фильтра
        let edge_price_max = $('#price_range_filter', $filters).data('max'); // крайнее значение фильтра

        let price_min = $('[name=price_min]', $filters).val() || ''; // текущее значение фильтра
        let price_max = $('[name=price_max]', $filters).val() || ''; // текущее значение фильтра

        let r_me = $('[name=r_me]', $filters).val();
        let r_city = $('[name=r_city]', $filters).val();

        let promo = $('[name="promo"]:checked:not(:disabled)', $filters).val();

        action +=
            // (tags ? '&tags=' + tags : '') +
            (services ? '&services=' + services : '') +
            ((price_min && (price_min != edge_price_min || price_max != edge_price_max)) ? '&price_min=' + price_min : '') +
            ((price_max && (price_min != edge_price_min || price_max != edge_price_max)) ? '&price_max=' + price_max : '') +
            // (food ? '&food=' + food : '') +
            ((r_me && r_me != 0) ? '&r_me=' + r_me : '') +
            ((r_city && r_city != 0) ? '&r_city=' + r_city : '') +
            (regions_list ? '&filter_regions_list=' + regions_list : '') +
            (resorts_list ? '&filter_resorts_list=' + resorts_list : '') +
            (waters_list ? '&filter_waters_list=' + waters_list : '') +
            (room_types ? '&filter_room_types=' + room_types : '') +
            // (object_types ? '&filter_object_types=' + object_types : '') +
            (promo ? '&promo=' + promo : '');
    }

    return action;
};
bases_search.save_query_history = function (str) {
    if (!str.trim()) return '';

    let data = {
        query_text: str,
        oper: 'add'
    };

    mo.edit(function (response) {
    }, 'bases', 'query_history', data);

};

// функции блока с фильтрами
bases_search.filter_init = function () {
    $filters = bases_search.$filters;

    // разворачивалка группы услуг
    $('.srv_group_header', $filters).click(function () {
        $(this).closest('.srv_group').toggleClass('in');
    });

    // применить фильтр
    $('a.go', bases_search.$btns_filters).click(function (event) {
        event.preventDefault();

        bases_search.load_bases();
        helper.animateScrollTo('#bases_search');

        $(this).addClass('filter_exists');
        $('a.reset', $filters).addClass('filter_exists');
        $(this).closest('.fixed_float_wrapper').height('auto');
        $('.left_side.open').removeClass('open');
    });

    // сросить фильтр
    $('a.reset', bases_search.$btns_filters).click(function (event) {
        event.preventDefault();

        // сбросить значение фильтров
        $('.checkbox.checked input', $filters).prop('checked', false);
        $('.checkbox.checked', $filters).removeClass('checked');

        $.map($('.scroll-range', $filters), function (el) {
            $(el).data('slider_reset')();
        });

        $('a.go', bases_search.$btns_filters).trigger('click').removeClass('filter_exists');
        $('a.reset', bases_search.$btns_filters).removeClass('filter_exists');
    });

    $('[name="region_id[]"], [name="resort_id[]"], [name="water_id[]"]', $filters).change(function() {
        $('a.go', bases_search.$btns_filters).click();
    });
};

// функции бара результатов
bases_search.results_bar_init = function () {
    var html_sorter = '<span class="sorter"><span class="step1 icon-sort_az"></span><span class="step2 icon-sort_za"></span></span>';
    $('.sort a .border').append(html_sorter);
    $('.sort a[data-by=rating] .sorter').addClass('step2');
    $('.sort a[data-by=price] .sorter').addClass('step1');

    $('.sort a').click(function (event) {
        event.preventDefault();

        var $sorter = $('.sorter', this);

        if ($(this).is('.active')) {
            if ($sorter.is('.step1'))
                $sorter.removeClass('step1').addClass('step2');
            else if ($sorter.is('.step2'))
                $sorter.removeClass('step2').addClass('step1');
        }

        $(this).addClass('active')
            .siblings().removeClass('active');

        var sort_by = $(this).data('by');
        var sort_dir = $sorter.is('.step1') ? 'asc' : 'desc';

        bases_search.results_sort(sort_by, sort_dir);
    });

    // вид отображения результатов
    $('.type_view a', bases_search.$results_bar).click(function (event) {
        event.preventDefault();

        $(this).addClass('active').siblings().removeClass('active');

        let type_view = $(this).attr('rel');

        $('[name=type_view]', bases_search.$results_bar).val(type_view);
        $('a.go', bases_search.$btns_filters).click();
    });

    // ymaps.ready(function () {
    //     $('.type_view a.on_map.active', bases_search.$results_bar).click();
    // });

    // выезжающее меню для мобильной версии
    $('.search_table .show_filter').click(function (event) {
        event.preventDefault();
        $('.left_side').addClass('open');
        $('.left_side').after('<div class="filter_bg"></div>');

        $('.filter_bg').click(function (e) {
            $('.left_side').removeClass('open');
            $(this).remove();
        });

        var lastX = 0;
        $('.filter_bg').bind('touchmove.Menu', function (e) {
            e.preventDefault();
            var currentX = e.originalEvent.touches[0].clientX;
            if (currentX > lastX) {
                $('.left_side').removeClass('open');
                $(this).remove();
            }
            lastY = currentX;
        });
    });
};

bases_search.insert_results_regular = function (result) {
    $('#type_view_0').show();
    $('#type_view_1').hide();

    let html = result.result;

    if (result.records * 1) {
        $('.els .el.empty', bases_search.$results).remove();
        bases_search.$results_pagination.html(result.pagination).show();
    } else {
        $('.els', bases_search.$results).html('<div class="el empty">Базы не найдены :(. Пожалуйста, измените условия поиска</div>');
        bases_search.$results_pagination.hide();
    }

    $('.els', bases_search.$results).append(html);
    $('.els .el:not(.empty)', bases_search.$results).show();

    if (result.records_exact_match) {
        $('#bases_results_pagination_top .count').html(result.records_exact_match);
        $('#bases_results_pagination_top .count').removeClass('hidden');
    } else {
        $('#bases_results_pagination_top .count').addClass('hidden');
    }
    $('#bases_results_pagination_top').removeClass('hidden');

    // подгрузка слайдеров
    setTimeout(function () {
        $.map($('.els .el:not(.empty)', bases_search.$results), function (el) {
            bases_search.load_slider($(el));
        });
    }, 500);
};

// сортировка результатов
bases_search.results_sort = function (sort_by, sort_dir) {
    bases_search.load_bases('', 0, '&sort_by=' + sort_by + '&sort_dir=' + sort_dir);
};

// функции результатов
bases_search.results_init = function () {
    $('.el:not(.empty)', bases_search.$results).show();

    bases_search.$results.on('click', '.rooms a.show_all_rooms', function (event) {
        event.preventDefault();

        $(this).hide().nextAll('.room').removeClass('hidden');
    });

    $(bases_search.$results_pagination).on('click', "a", function (event) {
        event.preventDefault();

        if ($(this).is('.current') || $(this).is('.points')) return;

        let p = $(this).data('p');

        helper.animateScrollTo('#bases_search');
        mo.preloader(true, bases_search.$results);
        setTimeout(function () {
            mo.preloader(false, bases_search.$results);
        }, 1000);
        $('html, body').animate({
            scrollTop: $(".search_table").offset().top
        }, 1000);
        bases_search.load_bases('', 0, '&page=' + p);
    });
};

bases_search.tabs_init = function () {
    var $block = $('[data-search-switcher]');
    var $links = $block.find('[data-link]');
    var $tabs = $block.find('[data-tab]');

    $links.click(function(e) {
        e.preventDefault();

        var $link = $(this);
        var i = $link.index();
        var $tab = $tabs.eq(i);

        $links.removeClass('active');
        $link.addClass('active');

        $tabs.hide();
        $tab.show();

        if (!$tab.data('loaded')) {
            var html = $tab.attr('data-html');

            if (html) {
                $tab.html(html);
                // jquery removes script tags
                $tab[0].innerHTML = html;
            }

            $tab.data('loaded', '1');
        }
    });
};

// Строковая функция, производит замену символа по его индексу в строке.
// @ToDo: Может быть полезна. Может добавить в helper.js?
String.prototype.replaceAt = function (index, replacement) {
    return this.substr(0, index) + replacement + this.substr(index + replacement.length);
};
// Строковая функция, капитализатор
String.prototype.capitalize = function (string, eachWord) {
    if (string === undefined || !string) return ''; else string = String(string);
    if (!(eachWord === undefined || !eachWord)) {
        var tmpStr = '';
        string.split(/\s/g).forEach(function (word) {
            tmpStr += word.capitalize();
        });
        return tmpStr;
    }
    return String(String(string).substr(0, 1).toUpperCase() + String(string).substr(1, string.length));
};